<script setup>
import IconUi from '../components/ui/IconUi.vue';

const props = defineProps({
   title: String,
   description: String,
});

const dict = window.detailsDict

</script>

<template>
   <div class="about_full">
      <div class="about_full--item">
         <IconUi name="share" color="var(--data_color_additional_text)" />
         <div>
            <div class="about_full--title">{{ dict.block_1_main }}</div>
            <div class="jECfAfwhE about_full--min_text">
               {{ dict.block_1_additional_1 }} <u>{{ dict.block_1_additional_2 }}</u>…
            </div>
         </div>
      </div>

      <div class="about_full--item">
         <IconUi name="cloud" color="var(--data_color_additional_text)" />
         <div>
            <div class="about_full--title">
               {{ dict.block_2_main }}
            </div>
            <div class="jECfAfwhE about_full--min_text">{{ dict.block_2_additional_1 }}
            </div>
         </div>
      </div>

      <div class="about_full--item">
         <IconUi name="lock" color="var(--data_color_additional_text)" />
         <div class="about_full--title">{{ dict.block_3_main }}</div>
      </div>

      <div class="about_full--item">
         <IconUi name="trash" color="var(--data_color_additional_text)" />
         <div class="about_full--title">{{ dict.block_4_main }}</div>
      </div>

      <div class="about_full--item">
         <div>
            <div class="about_full--last_item">
               <a class="about_full--last_item_a">{{ dict.button_end }}</a>
            </div>
         </div>
      </div>
   </div>
</template>

<style lang="scss" scoped>
.about_full {
   border: 1px solid var(--data_color_additional_border);
   // border: 1px solid var(--data_color_additional_text);
   // border-color: rgb(218, 220, 224);
   border-radius: 8px;
   margin-top: 30px;
   padding: 20px 20px 0;
   font-size: calc(1.0rem * var(--app-font-size));

   &--item {
      display: flex;
      padding: 10px 6px;
      color: var(--data_color_additional_text);
      gap: 24px;
   }

   &--title {
      // font-size: calc(1.125rem * var(--app-font-size));
   }

   &--last_item {
      padding: 5px 14px;
      margin-bottom: 12px;
   }

   &--last_item_a {
      color: var(--app_marked_text_color);
   }

   &--min_text {
      font-size: 14px;
      font-size: calc(0.825rem* var(--app-font-size));
   }

}

.T75ofwhEyae {
   display: block;
   border-style: none;
   max-width: 100%;
   height: min-content;
}

.jECfAfwhE {
   margin-top: 5px;
}
</style>
